import React, { useMemo } from 'react';
import Constants from '../../helpers/constants';
import { useSelector } from 'react-redux';
import { getConformedValue } from './phone_format_input';
import { conformToMask } from 'react-text-mask';
import CommentIcon from '@mui/icons-material/Comment';

const getCustomerIdPrefix = (lenderCode) =>
  Constants.LENDER_PREFIX.find((p) => lenderCode?.toLowerCase()?.includes(p.code))?.prefix ?? '';

const phoneLink = (phone) => (
  <a
    id="qa-footer-phone"
    className="footer-phone"
    href={`tel: +1-${
      conformToMask(phone, [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]).conformedValue
    }`}
  >
    {getConformedValue(phone)}
  </a>
);

const mailLink = (email) => (
  <a id="qa-footer-email" className="footer-email" href={'mailto:' + email}>
    {email}
  </a>
);

const generalSupportHours = (
  <div className="footer-hours">
    M-F: 7:00 am - 6:00 pm PT <br />
    Saturday: 7:00 am - 4:00 pm PT <br />
    Sunday: Closed
  </div>
);

const uwSupportHours = (
  <div className="footer-hours">
    M-F: 10:00 am - 6:00 pm PT <br />
    Saturday & Sunday: Closed
  </div>
);

const FooterRouting = ({ children }) => {
  const customerId = useSelector((redux) => redux?.customer?.id);
  const lenderCode = useSelector((redux) => redux?.lenderCode); //customer lender code
  const traceId = sessionStorage.getItem('fetchTraceId');

  const supportIds = useMemo(
    () => (
      <div className="footer-ids">
        <div className="id-container">
          {customerId && (
            <div className="footer-customer-id">{`Customer ID: ${getCustomerIdPrefix(lenderCode)}-${customerId}`}</div>
          )}
          {traceId && <span id="qa-traceId">Help ID: {traceId}</span>}
        </div>
      </div>
    ),
    [customerId, lenderCode, traceId]
  );

  return (
    <footer className="page-footer">
      <div id="footer-container-id" className="footer-container">
        <div className="company-info">
          <div className="footer-header">Have a question?</div>
          <div className="footer-detail-text">
            <CommentIcon className="chat-icon" />
            <span id="qa-footer-team">Contact the Concert Support Team:</span>
          </div>
          <div className="footer-content">
            <div>
              {phoneLink(Constants.GENERAL_SUPPORT_PHONE)} (call/text) <br />
              {mailLink(Constants.PARTNER_SUPPORT_EMAIL)}
            </div>
            <div>
              General Support Hours:
              {generalSupportHours}
            </div>
            <div>
              Underwriting Hours:
              {uwSupportHours}
            </div>
          </div>
          {supportIds}
        </div>
        {children}
      </div>
    </footer>
  );
};

export default FooterRouting;
